<template>
    <div id="voucherLog">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10">
                    <el-button-group>
                        <el-button type="danger"  icon="el-icon-delete" ></el-button>
                        <el-button type="info" icon="el-icon-download">
                            导出码库
                        </el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="4">
                    <!-- <el-tag type="info">{{tickedName}}</el-tag> -->
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入券码" v-model="input5" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            <el-row class="voucherList">
                <el-col :span="24">
                    <el-table
                        ref="multipleTable"
                        :data="tableData3"
                        tooltip-effect="dark"
                        style="100%"
                        max-height="400"
                    >
                        <el-table-column
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            label="券ID"
                            prop="voucherId"
                            width="210">
                            <template slot-scope="scope">{{ scope.row.voucherId }}</template>
                        </el-table-column>
                        <el-table-column
                            label="使用日期"
                            prop="transationDate"
                        >
                        </el-table-column>
                        <el-table-column
                            label="免费招待"
                            prop="complimentary"
                            width="80"
                        >
                        </el-table-column>
                        <el-table-column
                            label="类型编号"
                            prop="typeCode"
                            width="100"
                        >
                        </el-table-column>
                        <el-table-column
                            label="创建时间"
                            prop="creatDate"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            label="创建用户"
                            prop="creatUser"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>

    </div>
</template>
<style lang="less">
    #voucherLog{
        .voucherList{
            margin: 20px 0;
        }
    }
</style>
<script>

export default {
    data(){
        return {
            input5:'',
            tableData3:[
                {
                    voucherId:'111111',
                    transationDate:'2019-09-21',
                    complimentary:'是',
                    typeCode:'类型编号',
                    creatDate :"2019-04-04 16:56",
                    creatUser:'001'
                }
            ]
        }
    },
    created (){
    //    console.log(this.$route.query.name)  //获取到店铺名称
    }
}
</script>
